import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TreeNode } from '../components/tree/tree.component';

@Injectable({
	providedIn: 'root'
})
export class TreeNodeService {
	private nodesSubject: Subject<TreeNode[]> = new Subject();
	readonly nodes = this.nodesSubject.asObservable();

	setNodes(nodes: TreeNode[]) {
		this.nodesSubject.next(nodes);
	}
}
